import { useChatFilterContext } from "contexts/ChatFilterContext";
import { useEntityChatFilter } from "contexts/EntityChatFilterContext";
type ChatFilterPicks = {
  entityIds: string[] | null;
  seasons: string[] | null;
  isUnreadOnly: boolean;
  isPendingActionOnly: boolean;
};

export const useChatFilterPicks = (): ChatFilterPicks => {
  const customerPicks = useEntityChatFilter();
  const {
    filters: {
      ENTITY: agentEntityIds,
      SEASON: agentSeasons,
      IS_PENDING_ACTION: isAgentPendingActionOnly,
    },
  } = useChatFilterContext();

  return {
    entityIds: customerPicks.selectedEntityIds ?? agentEntityIds,
    seasons: customerPicks.selectedSeasons ?? agentSeasons,
    isUnreadOnly: customerPicks.isUnreadOnly,
    isPendingActionOnly:
      customerPicks.isPendingActionOnly || isAgentPendingActionOnly,
  };
};
